import { render, staticRenderFns } from "./DelMapping.vue?vue&type=template&id=d25467e8&scoped=true"
import script from "./DelMapping.vue?vue&type=script&lang=js"
export * from "./DelMapping.vue?vue&type=script&lang=js"
import style0 from "./DelMapping.vue?vue&type=style&index=0&id=d25467e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d25467e8",
  null
  
)

export default component.exports